import src from "IMAGE";
export default { src, width: 356, height: 69, blurWidth: 0, blurHeight: 0};
